import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { AssistanceServiceTripsDTO } from "../models/AssistanceServiceTrips/AssistanceServiceTripsDTO";
import { CreateAssistanceServiceTripsDTO } from "../models/AssistanceServiceTrips/CreateAssistanceServiceTripsDTO";
import { TotalDebtKmDTO } from "../models/AssistanceServiceTrips/TotalDebtKmDTO";
import { Parameter } from "../models/Parameter";
import { RecordTypeDTO } from "../models/RecordType/RecordTypeDTO";
import { APIService } from "./APIService";

export class AssistanceServiceTripsService {

    async Create(createAssistanceTrip: CreateAssistanceServiceTripsDTO): Promise<MessagingHelper<string>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceServiceTrips/Create`,
                {
                    ...createAssistanceTrip
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + APIService.GetToken()
                    }
                }
            )

            return response.data;
        }
        catch (error) {
            return new MessagingHelper<string>(false, "Erro ao ligar ao servidor para criar a deslocação na assistência", "");
        };
    }

    async GetTypes(type: string): Promise<MessagingHelper<RecordTypeDTO[]>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/RecordTypes/GetTypes`,
                {
                    params: { category: type },
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + APIService.GetToken()
                    }
                }
            )

            return response.data;
        } catch (error) {
            return new MessagingHelper<RecordTypeDTO[]>(false, "Erro ao ligar ao servidor para obter tipos de deslocação", []);
        };
    }

    async GetAll(sortingParameters: Parameter[], currentPage: number, pageSize: number, assistanceId: number): Promise<PaginatedList<AssistanceServiceTripsDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceServiceTrips/GetAll?assistanceId=${assistanceId}`,
                {
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<AssistanceServiceTripsDTO>(
                false,
                "Erro ao ligar ao servidor para obter a informação das deslocações",
                "",
                [],
                0,
            );
        }
    }

    async RemoveServiceTripFromAssistance(id: number): Promise<MessagingHelper<null>> {
        try {
          var response = await APIService.Axios().delete(
            `${APIService.GetURL()}/AssistanceServiceTrips/RemoveServiceTripFromAssistance/${id}`,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + APIService.GetToken(),
              },
            }
          );
          return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para remover a deslocação da assistência",
                null
            );
        }
    }

    async InsertTotalDebtKm(totalDebtKm: TotalDebtKmDTO): Promise<MessagingHelper<string>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceServiceTrips/InsertTotalKm`,
                {...totalDebtKm},
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + APIService.GetToken()
                    }
                }
            );
            
            return response.data;
        } catch (error) {
            return new MessagingHelper<string>(false, "Erro ao ligar ao servidor para registar os km's a faturar na assistência", "");
        }
    }
}